import { BACKGROUND_COLOR_PREFIX, TEXT_COLOR_PREFIX } from './plugins/textColor/textColorConstants';

export const isColorStyle = (style) => style.startsWith(TEXT_COLOR_PREFIX);
export const isBackgroundStyle = (style) => style.startsWith(BACKGROUND_COLOR_PREFIX);
